export const MemberOrderEvaluationEn = {
    xunjiadang:'Order evaluation',
    wodepingji:'My evaluation',
    daipingjia:'Order to be evaluated',
    didangneirong:'Order content',
    pingjianeirong:'Evaluation content',
    jiage:'price',
    zhuantai:'status',
    caozuo:'operation',
    pingjiazhuantai:'Evaluation state'
}


// WEBPACK FOOTER //
// ./src/lang/member/MemberOrderEvaluation/MemberOrderEvaluationEn.js